import { CG2BusinessCategories } from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export const getBusinessCategories = async (token: string) => {
  const { data } = await apiInstance(token).get<CG2BusinessCategories>(
    `/backoffice/master-data/business-categories`
  );
  return data;
};

const BusinessCategoryQueryKey = 'BusinessCategory';

function getBusinessCategoryQueryOptions(token: string) {
  return queryOptions({
    queryKey: [BusinessCategoryQueryKey],
    queryFn: () => getBusinessCategories(token),
    select(data) {
      return data.data.filter((it) => it.cg_2_business_category_desc !== '');
    },
    staleTime: 60_000,
    retry: false,
  });
}

export const useBusinessCategories = (hookOptions?: { enabled?: boolean }) => {
  const token = useAuthStore((s) => s.access_token);

  const base = getBusinessCategoryQueryOptions(token);
  const query = useQuery({ ...base, enabled: hookOptions?.enabled ?? true });

  const selectOptions = useMemo(() => {
    return (query.data || []).map((it) => ({
      label: it.cg_2_business_category_desc,
      value: it.cg_2_business_category,
    }));
  }, [query.data]);

  const maps = useMemo(() => {
    return selectOptions.reduce((p: Record<string, string>, c) => {
      p[c.value] = c.label;
      return p;
    }, {});
  }, [selectOptions]);

  return {
    ...query,
    options: selectOptions,
    maps,
  };
};
